module.exports = __webpack_public_path__ + "50fda4be70d864007a9033bcf9501de7.jpg";